import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function AboutPreview() {
  return (
    <section className="py-24 bg-white" data-testid="about-preview-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 grid lg:grid-cols-2 gap-14 items-center">
        <div className="rounded-3xl overflow-hidden shadow-sm order-2 lg:order-1">
          <img
            src="https://images.unsplash.com/photo-1760074032615-2e35d8c5e5ae?crop=entropy&cs=srgb&fm=jpg&q=85"
            alt="Laboratory researcher"
            className="w-full h-[380px] object-cover"
          />
        </div>
        <div className="order-1 lg:order-2">
          <span className="text-xs tracking-[0.2em] uppercase font-semibold text-brandblue-600">About True Impact Peptides</span>
          <h2 className="mt-3 text-3xl sm:text-4xl tracking-tight font-medium text-slate-900 font-display leading-tight">
            Committed to Scientific Excellence
          </h2>
          <p className="mt-5 text-base text-slate-600 leading-relaxed">
            True Impact Peptides was founded on a mission to supply the research community with the highest caliber Research Use Only compounds, backed by comprehensive documentation and independent quality verification.
          </p>
          <p className="mt-4 text-base text-slate-600 leading-relaxed">
            Our vision is a research supply chain defined by transparency and rigor — where every batch tells a verifiable, traceable story.
          </p>
          <Link to="/about">
            <Button size="lg" variant="outline" className="mt-8 rounded-full border-slate-300" data-testid="about-preview-cta-btn">
              Learn More About Us <ArrowRight className="h-4 w-4 ml-2" />
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
